<template>
  <section id="landing-hero" class="bg-white">
    <div class="relative isolate">
      <svg
        class="absolute inset-0 -z-10 size-full [mask-image:radial-gradient(100%_100%_at_top_right,white,transparent)] stroke-gray-200"
        aria-hidden="true"
      >
        <defs>
          <pattern
            id="83fd4e5a-9d52-42fc-97b6-718e5d7ee527"
            width="200"
            height="200"
            x="50%"
            y="-1"
            patternUnits="userSpaceOnUse"
          >
            <path d="M100 200V.5M.5 .5H200" fill="none" />
          </pattern>
        </defs>
        <svg x="50%" y="-1" class="overflow-visible fill-gray-50">
          <path
            d="M-100.5 0h201v201h-201Z M699.5 0h201v201h-201Z M499.5 400h201v201h-201Z M-300.5 600h201v201h-201Z"
            stroke-width="0"
          />
        </svg>
        <rect
          width="100%"
          height="100%"
          stroke-width="0"
          fill="url(#83fd4e5a-9d52-42fc-97b6-718e5d7ee527)"
        />
      </svg>
      <div
        class="mx-auto max-w-7xl px-6 pt-32 pb-24 sm:py-32 lg:flex lg:items-center lg:gap-x-10 lg:px-8 lg:py-40"
      >
        <div class="mx-auto max-w-2xl lg:mx-0 lg:flex-auto">
          <h1
            class="text-5xl font-semibold tracking-tight text-pretty text-gray-900 sm:text-7xl"
          >
            <span class="inline-block relative">
              <img
                src="/graphics/green/burst-1.svg"
                alt="Burst squiggle"
                class="absolute -left-10 -top-6 w-12"
                height="16"
                width="48"
              />
              Be
            </span>
            a bigger part of school life with our Juniper Education
            <TextUnderline>mobile app</TextUnderline>
          </h1>
          <p
            class="mt-8 text-lg font-medium text-pretty text-gray-500 sm:text-xl/8"
          >
            Not just the boring big brother type stuff like attendance and
            behaviour (though we’ve got that too, it is important), but the
            stuff that makes you smile. Class pictures, the little awards
            they’re so proud of, house points and achievements.
          </p>
          <p
            class="mt-8 text-lg font-medium text-pretty text-gray-500 sm:text-xl/8"
          >
            When schools and parents talk to each other, kids do better.
          </p>
          <div
            class="mt-10 flex flex-col justify-start gap-y-2 gap-x-6 sm:flex-row sm:items-center"
          >
            <a
              href="https://apps.apple.com/ie/app/juniper-education/id6514314038"
              @click="trackAppStoreClick"
              target="_blank"
              rel="noopener noreferrer"
              class="rounded-md bg-gray-900 w-fit transition-colors px-3.5 py-2.5 text-sm font-semibold text-white shadow-xs flex gap-2 items-center hover:bg-gray-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-600"
            >
              <i class="fa-brands fa-apple w-10 text-3xl"></i>
              <div class="flex flex-col">
                <small>Download from the</small>
                <span>App Store</span>
              </div>
            </a>
            <a
              href="https://play.google.com/store/apps/details?id=com.juniper.mobile.app"
              @click="trackGooglePlayClick"
              target="_blank"
              rel="noopener noreferrer"
              class="rounded-md bg-green-600 w-fit transition-colors px-3.5 py-2.5 text-sm font-semibold text-white shadow-xs flex gap-2 items-center hover:bg-green-700 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-green-600"
            >
              <i class="fa-brands fa-android w-10 text-3xl"></i>
              <div class="flex flex-col">
                <small>Download from</small>
                <span>Google Play</span>
              </div>
            </a>
          </div>
        </div>
        <div
          data-aos="fade-left"
          class="mt-16 sm:mt-24 lg:mt-0 lg:shrink-0 lg:grow"
        >
          <img
            src="/mockups/11.webp"
            class="mx-auto w-[22.875rem] max-w-full h-auto drop-shadow-xl"
            alt="Mobile mockup prototype"
            height="724"
            width="366"
          />
        </div>
      </div>
    </div>
  </section>
</template>
<script setup lang="ts">
import TextUnderline from "./TextUnderline.vue";
import { track } from "@vercel/analytics";

const trackAppStoreClick = () => {
  track("download_app", { platform: "ios", page: "parent" });
};

const trackGooglePlayClick = () => {
  track("download_app", { platform: "android", page: "parent" });
};
</script>
